import Button, { ButtonProps } from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import React from 'react';

import DialogMigrate from '../Dialog/DialogMigrate';
import useStyles from './quizArchiveDialogStyles';

const ArchiveButton = styled(Button)<ButtonProps>(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#A70D0D',
  },
  backgroundColor: '#A70D0D',
  borderRadius: '4px',
  color: theme.palette.getContrastText('#A70D0D'),
  height: '48px',
  width: '170px',
}));

type QuizArchiveDialogProps = {
  isOpen: boolean;
  closeDialog: (response: boolean, id?: string) => void;
};

const QuizArchiveDialog: React.FC<any> = (props: QuizArchiveDialogProps) => {
  const classes = useStyles();
  const { isOpen, closeDialog } = props;

  return (
    <DialogMigrate
      aria-labelledby="quiz-archive-dialog"
      className={classes.dialog}
      maxWidth="md"
      open={isOpen}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={() => {
        closeDialog(false);
      }}>
      <DialogTitle>
        <div className={classes.title}>
          Are you sure you want to archive this quiz?
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.subTitle}>
          This will be removed from quizzes. You will not be able to undo this
          once submitted.
        </div>
      </DialogContent>
      <Divider className={classes.divider} />
      <DialogActions className={classes.dialogAction}>
        <Link
          className={classes.cancelLink}
          color="inherit"
          underline="always"
          onClick={() => {
            closeDialog(false);
          }}>
          NO, CANCEL
        </Link>
        <ArchiveButton type={'button'} variant="contained">
          <Typography
            className={classes.archiveBtn}
            onClick={() => {
              closeDialog(true);
            }}>
            YES, ARCHIVE
          </Typography>
        </ArchiveButton>
      </DialogActions>
    </DialogMigrate>
  );
};

export default observer(QuizArchiveDialog);
